import { Module } from "vuex";
import { profileApi, ApiException, Profile } from '@/services/api';

import { RootState } from '..';


export interface ProfileState {
  bound: boolean;
  loading: boolean;
  profile: Profile | null;
}

// Mutation types
const SET_PROFILE = 'SET_PROFILE';
const SET_BOUND = 'SET_BOUND';
const SET_LOADING = 'SET_LOADING';

const AuthModule: Module<ProfileState, RootState> = {
  state: {
    bound: false,
    profile: null,
    loading: false,
  },
  mutations: {
    [SET_PROFILE](state, payload) {
      state.profile = payload;
    },
    [SET_BOUND](state, payload) {
      state.bound = payload;
    },
    [SET_LOADING](state, payload) {
      state.loading = payload;
    }
  },
  actions: {
    
    /**
     * Fetch and bind private profile data
     */
    async bindProfile({ commit, state, rootGetters, getters }) {
      if (getters.hasProfile || state.loading) {
        return; // already loaded
      }

      commit(SET_LOADING, true);
      await rootGetters.authInit;
      const id = rootGetters.user.uid;

      try {
        const profile = await profileApi.getProfile(id);
        commit(SET_PROFILE, profile);
        commit(SET_BOUND, true);
      } catch (error) {
        if (error instanceof ApiException && error.status === 404) {
          // Profile doesn't exist yet, set to empty object
          commit(SET_PROFILE, null);
          commit(SET_BOUND, true);
        } else {
          console.error('Failed to fetch profile:', error);
          throw error;
        }
      } finally {
        commit(SET_LOADING, false);
      }
    },

    /**
     * Persist private profile changes
     */
    async persistProfile({ rootGetters }, profile) {
      await rootGetters.authInit;
      const id = rootGetters.user.uid;
      
      // Apply business logic: residence only valid for CH and IT
      if (profile.country != 'CH' && profile.country != 'IT') {
        profile.residence = {};
      }

      await profileApi.updateProfile(id, profile);
    },
  },
  getters: {
    hasProfile(state) {
      return state.profile !== null;
    },
    profile(state) {
      return state.profile ? state.profile : false;
    },
    points(state) {
      return state.profile && state.profile.points ? state.profile.points % 100 : 0;
    },
    level(state) {
      return state.profile && state.profile.points ? Math.floor(state.profile.points / 100) + 1 : 0;
    }
  }
}

export default AuthModule
